import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const TrendViewWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 8px;
  /* No min-height: the card is a fixed PERFORMANCE_SECTION_HEIGHT, so anything taller escapes it
     and covers the section below, swallowing those clicks. Height comes from .content's flex-grow. */
  min-height: 0;

  .overall-performance-trend-chart-title {
    color: ${theme.colors.foreground};
    font-family: Quicksand, sans-serif;
    font-size: 40px;
    font-style: normal;
    font-weight: 500;
    line-height: 60px;
  }
`

export const ChartWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  position: relative;
  width: 100%;

  #overall-performance-chart-svg,
  .overall-performance-chart-svg {
    border-radius: ${theme.attributes.borderRadius.small};
    z-index: 10;
    overflow: visible;

    .hover-circle-outer,
    .hover-circle-inner {
      z-index: 1000000000;
    }
  }

  .overall-performance-chart-tooltip {
    display: none;
    position: absolute;
    opacity: 1;
    padding: ${theme.spacing.small}px;
    gap: ${theme.spacing.sm}px;
    border-radius: 12px;
    border: 1px solid ${theme.colors.menuItemHover};
    background: ${theme.colors.surfaceContainerBackground};
    box-shadow: ${theme.colors.tooltipShadow};
    color: ${theme.colors.foreground};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xLarge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 24px;
    letter-spacing: 0.1px;
    width: 175px;
    height: 80px;
    z-index: 100000 !important;
    pointer-events: none;

    .tooltip-date {
      color: ${theme.colors.foreground};
      font-family: Quicksand, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      margin: 0;
    }

    .tooltip-performance,
    .tooltip-units {
      color: ${theme.colors.textSecondary};
      font-family: Quicksand, sans-serif;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px;
    }

    .tooltip-performance {
      font-size: ${theme.typography.fontSize.xxxLarge};
      line-height: 32px;
      margin: 0 0 4px 0;
    }

    .tooltip-units {
      font-size: ${theme.typography.fontSize.medium};
      line-height: 16px;
      letter-spacing: 0.4px;
      margin: 0;
    }

    .severity-text {
      text-transform: capitalize;
    }
  }
`

export const EmptyStateWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 6px;
  margin-top: 41px;

  .title {
    color: #e9e0e4;
    font-family: Quicksand, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-top: 2px;
  }

  .description {
    color: #d0c3cc;
    text-align: center;
    font-family: Quicksand, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    max-width: 270px;
  }

  html[data-theme='light'] & {
    .title {
      color: ${theme.colors.menuItemText};
    }

    .description {
      color: ${theme.colors.devicesSecondaryText};
    }

    svg path {
      stroke: ${theme.colors.devicesSecondaryText};
    }
  }
`

export const Tooltip = styled(Box)`
  position: absolute;
  background: ${theme.colors.backgroundDarker};
  border: 1px solid ${theme.colors.borderMedium};
  border-radius: ${theme.attributes.borderRadius.secondary};
  padding: ${theme.spacing.small}px;
  pointer-events: none;
  z-index: 1000;

  .tooltip-date {
    color: ${theme.colors.foreground};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.medium};
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 16px;
    margin-bottom: 2px;
  }

  .tooltip-value {
    color: ${theme.colors.cta};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
  }
`
